import { render, staticRenderFns } from "./itemsCard3.vue?vue&type=template&id=8c122e4c&"
import script from "./itemsCard3.vue?vue&type=script&lang=js&"
export * from "./itemsCard3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports